export const DefaultUniformStyleValue = {
  opacity: 1,
  stroke: [1, 0, 0, 1],
  offsets: [0, 0],
  rotation: 0,
  extrusionBase: 0,
  strokeOpacity: 1,
  thetaOffset: 0.314
};
export const DefaultUniformStyleType = {
  opacity: 'float',
  stroke: 'vec4',
  offsets: 'vec2',
  textOffset: 'vec2',
  rotation: 'float',
  extrusionBase: 'float',
  strokeOpacity: 'float',
  thetaOffset: 'float'
};